import { Button } from "@/src/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/src/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/src/components/ui/Drawer";
import { useMediaQuery } from "@/src/hooks/useMediaQuery";
import clsx from "clsx";
import * as React from "react";

interface ResponsiveDrawerProps {
  title?: string;
  description?: string;
  trigger?: React.ReactNode;
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  dialogClassName?: string;
  drawerClassName?: string;
}

export function ResponsiveDrawer({
  title = "Example Title",
  description = "Example Description",
  trigger = <Button variant="outline">Edit Profile</Button>,
  children,
  open,
  onOpenChange,
  dialogClassName = "sm:max-w-[425px]",
  drawerClassName,
}: ResponsiveDrawerProps) {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const isLargeScreen = useMediaQuery("(min-width: 1024px)");

  const isOpen = open !== undefined ? open : internalOpen;
  const setIsOpen = onOpenChange || setInternalOpen;

  if (isLargeScreen) {
    return (
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
        <DialogContent className={dialogClassName}>
          <DialogHeader>
            <DialogTitle className="mb-4 text-center font-body text-sm !font-medium">
              {title}
            </DialogTitle>
            {description && (
              <DialogDescription className="sr-only">
                {description}
              </DialogDescription>
            )}
          </DialogHeader>
          {children}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      {trigger && <DrawerTrigger asChild>{trigger}</DrawerTrigger>}
      <DrawerContent className={clsx("bg-white", drawerClassName)}>
        <DrawerHeader className="mb-8 !p-0 text-left">
          <DrawerTitle className="text-center font-body text-sm !font-medium">
            {title}
          </DrawerTitle>
          {description && (
            <DrawerDescription className="sr-only">
              {description}
            </DrawerDescription>
          )}
        </DrawerHeader>
        <div className="px-4 pb-4">{children}</div>
      </DrawerContent>
    </Drawer>
  );
}
